<template>
  <!-- 尾程 柜子详情 -->
  <div class="WCabdetails">
    <el-card style="box-shadow: none; border: none">
      <div class="main time">
        <div class="box">
          <div class="label">
            <span>货柜代码:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.planName"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>柜号:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.containerNo"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>封号:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.originalNo"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>航名航次:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.shipNo"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>提单号:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.blNo"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>创建时间:</span>
          </div>
          <div class="cent">
            <el-date-picker
              disabled
              v-model="createTime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
        </div>
      </div>
      <div class="main time">
        <div class="box">
          <div class="label">
            <span>出发时间:</span>
          </div>
          <div class="cent">
            <el-date-picker
              disabled
              v-model="etdTime"
              type="datetime"
              placeholder="选择etd"
            ></el-date-picker>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>柜型:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.size"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>船公司:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.shipCompany"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>POL港:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.pol"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>POD港:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.podEnd"></el-input>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>是否拼柜:</span>
          </div>
          <div class="cent">
            <el-select disabled v-model="containerType" placeholder="请选择">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="main time">
        <div class="box">
          <div class="label">
            <span>到港时间:</span>
          </div>
          <div class="cent">
            <el-date-picker
              disabled
              v-model="etaTime"
              type="datetime"
              placeholder="选择eta"
            ></el-date-picker>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>拆柜方式:</span>
          </div>
          <div class="cent">
            <el-select disabled v-model="dispatchType" placeholder="请选择拆柜方式">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>拆柜时间:</span>
          </div>
          <div class="cent">
            <el-date-picker
              disabled
              v-model="dispatchTime"
              type="datetime"
              placeholder="选择拆柜时间"
            ></el-date-picker>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>是否清关:</span>
          </div>
          <div class="cent">
            <el-select disabled v-model="cabData.isClearance" placeholder="请选择是否清关">
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>是否提柜:</span>
          </div>
          <div class="cent">
            <el-select disabled v-model="cabData.isPick" placeholder="请选择是否提柜">
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="box">
          <div class="label">
            <span>备注:</span>
          </div>
          <div class="cent">
            <el-input disabled v-model="cabData.remark" type="textarea"></el-input>
          </div>
        </div>
      </div>

      <!-- 统计信息 -->
      <div style="margin: 20px 0; text-align: left;">
        <span style="font-size: 13px;line-height: 32px;font-weight: 600;">件/重/体：{{ctns}}CTNS/{{kgs}}KGS/{{cbm}}CBM</span>
      </div>
      
      <!-- 订单表格 - 显示和管理端一样的列 -->
      <el-table
        :data="orderData"
        tooltip-effect="dark"
        style="box-shadow: none"
        :cell-style="tableRowStyleName"
        border
        size="small"
      >
        <el-table-column property="mark" label="唛头/标记" width="170px">
          <template slot-scope="scope">
            <el-link type="primary"  @click="gettailDetails(scope.row)" :underline="false">{{scope.row.mark}}</el-link>
          </template>
        </el-table-column>
        <el-table-column property="newLogisticsStatus" label="最新状态" width="120">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.newLogisticsStatus"
              clearable
              style="width: 360px"
              placeholder=""
              disabled
            >
              <el-option
                v-for="item in cabStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column property="truckType" label="派送方式" width="100"></el-table-column>
        <el-table-column property="fbacode" label="目的仓" width="120"></el-table-column>
        <el-table-column property="fbaId" label="FBA#" width="100"></el-table-column>
        <el-table-column property="fbaPo" label="ReferenceId" width="120"></el-table-column>
        <el-table-column property="cnt" label="件数" width="80"></el-table-column>
        <el-table-column property="kg" label="重量（KG）" width="100"></el-table-column>
        <el-table-column property="cbm" label="体积（CBM）" width="100"></el-table-column>
        <el-table-column property="qty" label="数量" width="80"></el-table-column>
        <el-table-column property="productNameCn" label="产品名称" width="100"></el-table-column>
        <el-table-column property="size" label="尺寸（长宽高）" width="120"></el-table-column>
        <el-table-column property="truckNo" label="跟踪号" width="120"></el-table-column>
        <el-table-column property="createTime" :formatter="formatTime" label="创建时间" width="150"></el-table-column>

      </el-table>
    </el-card>
  </div>
</template>

<script>
import httpApi from "@/http/api";
import { formatTimeToStr } from "@/util/toLocaleString.js";

export default {
  name: "cabdetails",
  props: {
    plannames: { type: String },
  },
  data() {
    return {
      ctns: 0,
      kgs: 0,
      cbm: 0,
      
      createTime: "",
      etaTime: "",
      etdTime: "",
      dispatchTime: "",
      planName: this.plannames,
      containerId: "",
      orderData: [],
      cabData: {},
      newLogisticsStatus:"",
       //统一进度
      cabStatus: [
        { label: "已装柜", value: "4.5" },
        { label: "国内查验", value: "5" },
        { label: "国内报关放行", value: "6" },
        { label: "报关已放行", value: "15" },
        { label: "已开船/启航", value: "7" },
        { label: "已到港/落地", value: "8" },
        { label: "国外清关中", value: "9" },
        { label: "国外查验", value: "10" },
        { label: "已清关放行", value: "11" },
        { label: "已提柜", value: "12" },
        { label: "已出仓", value: "17" },
        { label: "已派送", value: "13" },
        { label: "已签收(不同步订单)", value: "14" },
      ],
      options: [
        { value: "0", label: "直送" },
        { value: "1", label: "拆柜" },
      ],
      options2: [
        { value: "0", label: "自拼" },
        { value: "1", label: "整柜" },
      ],
      options3: [
        { value: "0", label: "否" },
        { value: "1", label: "是" },
      ],
      
      dispatchType: "",
      containerType: "",
    };
  },
  
  methods: {
    //柜子详情
    initDetails() {
      let that = this;
      httpApi.cabView({ params: { planName: that.planName } }).then((res) => {
        if (res.data.code == "ok") {
          that.cabData = res.data.data;
          that.dispatchType = that.cabData.dispatchType;
          that.containerType = that.cabData.containerType;
          that.containerId = that.cabData.id;
          
          // 保持原来的时间转换
          that.createTime = new Date(that.cabData.createTime) * 1000;
          that.etaTime = new Date(that.cabData.eta) * 1000;
          that.etdTime = new Date(that.cabData.etd) * 1000;
          that.dispatchTime = new Date(that.cabData.dispatchTime) * 1000;
          
          this.initOrder2();
        } else {
          that.$message.error(res.data.message);
        }
      });
    },
    
    //柜子订单
    initOrder2() {
      let that = this;
      httpApi
        .contOrderList({
          params: { containerId: that.containerId },
        })
        .then((res) => {
          if (res.data.code == "ok") {
            that.orderData = res.data.data;
            // 计算总计
            this.calculateTotals();
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    
    //计算总计
    calculateTotals() {
      let ctns2 = 0;
      let kgs2 = 0;
      let cbm2 = 0;
      
      this.orderData.forEach(v => {
        ctns2 += (parseFloat(v.cnt) || 0);
        kgs2 += (parseFloat(v.kg) || 0);
        cbm2 += (parseFloat(v.cbm) || 0);
      });
      
      this.ctns = ctns2.toFixed(2);
      this.kgs = kgs2.toFixed(2);
      this.cbm = cbm2.toFixed(3);
    },
    //跳转到详情页
    gettailDetails(row){
      this.$router.push({
        path: "/WorderDetials/" + row.id
      });
    },
    //样式
    tableRowStyleName({row}) {
      if(row.orderLogStatusTxt == '已签收'){
        return 'background-color: #F0F8FF !important;';
      }
    },
    
    formatTime(row, column, cellValue) {
      if (!cellValue) return '';
      const date = new Date(cellValue * 1000);
      return formatTimeToStr(date, "yyyy-MM-dd");
    }
  },
  
  created() {
    this.initDetails();
  },
  
  watch: {
    plannames(val) {
      this.planName = val;
      this.initDetails();
    },
  },
  
  filters: {
    formatDate: function (time) {
      if (time != null && time != "") {
        var date = new Date(time * 1000);
        return formatTimeToStr(date, "yyyy-MM-dd");
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 32px;
  margin-bottom: 2px;
  display: flex;
  .box {
    width: 250px;
    display: flex;
    margin-left: 10px;
    .label {
      width: 60px;
      font-weight: bold;
      height: 32px;
      line-height: 32px;
    }
    .cent {
      width: 185px;
      margin-left: 5px;
    }
  }
}
.time {
  .box {
    width: 250px;
    .el-date-editor {
      width: 185px;
    }
  }
}

// 添加表格样式
::v-deep .el-table td,
::v-deep .el-table th {
  padding: 4px 0;
  text-align: center !important;
}

::v-deep .el-table .cell {
  padding: 0 4px;
  font-size: 12px;
}
</style>